export const getCurrentBuilding = (buildings, bin) => {
  // bin from the URL is a string; building.bin (PK) is a number — coerce both.
  return buildings.find(building => String(building.bin) === String(bin)) || {}
}
